import React from 'react';
import {Actions} from '../actions';
import {connect} from 'react-redux';
import Account from "../components/Account";
import mixpanel from "mixpanel-browser";

const mapStateToProps = (state, ownProps) => {
    return {
        profile: state.profile,
        mfaRequired: state.auth.mfaRequired,
        ...ownProps
    };
};

export default connect(mapStateToProps, Actions)(Account);